var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBadgeSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21875 6.99855C0.21875 3.27143 3.24018 0.25 6.9673 0.25C10.6944 0.25 13.7158 3.27143 13.7158 6.99855C13.7158 10.7257 10.6944 13.7471 6.9673 13.7471C3.24018 13.7471 0.21875 10.7257 0.21875 6.99855ZM6.96741 3.5C6.55319 3.5 6.21741 3.83579 6.21741 4.25V4.255C6.21741 4.66921 6.55319 5.005 6.96741 5.005H6.97241C7.38662 5.005 7.72241 4.66921 7.72241 4.255V4.25C7.72241 3.83579 7.38662 3.5 6.97241 3.5H6.96741ZM5.79671 6.83395C5.91448 7.06948 6.13945 7.21596 6.38291 7.24384L6.00352 8.76139C5.74453 9.79735 6.81994 10.66 7.77504 10.1825L7.77507 10.1824L7.80272 10.1686C8.1732 9.98337 8.32335 9.53286 8.1381 9.16238C8.02033 8.92686 7.79536 8.78038 7.55191 8.75251L7.93129 7.23496C8.19028 6.199 7.11488 5.33634 6.15977 5.81389L6.15977 5.81389L6.13212 5.82772C5.76163 6.01296 5.61147 6.46347 5.79671 6.83395Z",
    fill: "#0E7241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadgeSuccess);
export default __webpack_public_path__ + "static/media/iconBadgeSuccess.60cce1ed1968558893b6abb591231aa2.svg";
export { ForwardRef as ReactComponent };